<template>
  <div class="dashboard">
    <!-- ========== 批发商品牌数据面板（新增） ========== -->
    <!-- 条件：批发商 且 有店铺/认证 -->
    <div v-if="isWholesaler && hasShop">
      <!-- 第一行：品牌信息 + 统计卡片 -->
      <el-row :gutter="20" style="margin-top: 4vh;">
        <el-col :span="8" style="height: 21.5vh;">
          <el-card class="box-card" >
            <div slot="header" class="clearfix">
              <span>品牌信息</span>
            </div>
            <div class="user-info">
              <el-avatar :src="brand.avatar || ''" size="large"></el-avatar>
              <div class="info">
                <div class="name">{{ brand.name }}</div>
                <div class="id">品牌ID: {{ brand.id }}</div>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>数据概览</span>
            </div>
            <div class="stat-cards">
              <div class="stat-item" @click="goTo('goods')">
                <div class="stat-num">{{ brandStats.goods_sum }}</div>
                <div class="stat-label">商品总数</div>
              </div>
              <div class="stat-item" @click="goTo('dealers')">
                <div class="stat-num">{{ brandStats.jx_sum }}</div>
                <div class="stat-label">经销商总数</div>
              </div>
              <div class="stat-item" @click="goTo('contracts')">
                <div class="stat-num">{{ brandStats.ht_sum }}</div>
                <div class="stat-label">合同总数</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 第二行：订单数图表 + 支付方式金额图表 -->
      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>订单统计</span>
            </div>
            <div ref="orderChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>支付方式金额</span>
            </div>
            <div ref="payChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- ========== 原有经销商/管理员/零售商面板 ========== -->
    <div v-else-if="hasShop">
      <!-- 第一行：用户信息 + 待办事项 -->
      <el-row :gutter="20" style="margin-top: 4vh;">
        <el-col :span="12" style="height: 21.5vh;">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>用户信息</span>
            </div>
            <div class="user-info">
              <el-avatar :src="user.avatar || ''" size="large"></el-avatar>
              <div class="info">
                <div class="role">{{ user.role }}</div>
                <div class="name">{{ user.name }}</div>
              </div>
              <!-- 零售商专属：绑定品牌方按钮 -->
              <div class="user-actions" v-if="userType === 'retailer'">
                <el-button type="primary" plain size="small" @click="bindBrand">
                  绑定品牌方
                </el-button>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>数据概览</span>
            </div>
              <div class="stat-cards">
                <div class="stat-item" @click="goTo('goods')">
                  <div class="stat-num">{{ jxdata.goods_sum }}</div>
                  <div class="stat-label">商品总数</div>
                </div>
                <div class="stat-item" @click="goTo('dealers')">
                  <div class="stat-num">{{ jxdata.order_sum }}</div>
                  <div class="stat-label">订单总数</div>
                </div>
              </div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 第二行：店铺图表 + 证件图表 -->
       <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>店铺审核统计</span>
            </div>
            <div ref="shopChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
       <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>证件审核统计</span>
            </div>
            <div ref="cardChart" style="height: 400px;"></div>
          </el-card>
        </el-col>
      </el-row>
    </div>

    <!-- ========== 无店铺/认证时的提示 ========== -->
    <div v-else>
      <!-- 店铺审核中 -->
      <div v-if="shopType" class="no-shop-tip">
        <el-empty description="店铺审核中">
          <div style="margin-top: 8px; color: #606266; font-size: 14px;">
            您的店铺申请已提交，请耐心等待审核
          </div>
          <div style="margin-top: 4px; color: #909399; font-size: 13px;">
            类型：{{ shopType }}
          </div>
        </el-empty>
      </div>

      <!-- 未申请店铺 -->
      <div v-else>
        <!-- 零售商：认证提示 -->
        <div v-if="userType === 'retailer'" class="no-shop-tip">
          <el-empty description="暂无认证">
            <el-button type="primary" @click="goAuth">前往认证</el-button>
          </el-empty>
          <div style="text-align: center; margin-top: 20px;">
            <el-button type="warning" plain @click="bindBrand">绑定品牌方</el-button>
          </div>
          <p style="text-align: center; color: #909399; font-size: 14px; margin-top: 10px;">
            请先完成认证，再绑定品牌方体验完整权益
          </p>
        </div>

        <!-- 批发商：注册店铺提示 -->
        <div v-if="userType === 'wholesaler'" class="no-shop-tip">
          <el-empty description="暂无店铺">
            <el-button type="primary" @click="goRegister">立即注册店铺</el-button>
          </el-empty>
          <p style="text-align: center; color: #909399; font-size: 14px; margin-top: -10px;">
            请先注册店铺体验完整权益
          </p>
        </div>
      </div>
    </div>

    <!-- ========== 绑定品牌方弹窗（保留零售商专用） ========== -->
    <el-dialog
      title="绑定品牌方"
      :visible.sync="bindDialogVisible"
      width="560px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <div v-loading="brandLoading" element-loading-text="加载品牌列表中...">
        <div v-if="!brandLoading && brandList.length === 0" class="brand-empty">
          <el-empty description="暂无品牌方可供选择" :image-size="80"></el-empty>
        </div>
        <el-radio-group
          v-else
          v-model="selectedBrandId"
          class="brand-radio-group"
          @change="handleBrandSelect"
        >
          <div
            v-for="brand in brandList"
            :key="brand.id"
            class="brand-item"
            :class="{ 'is-active': selectedBrandId === brand.id }"
            @click="selectedBrandId = brand.id; handleBrandSelect(brand)"
          >
            <el-radio :label="brand.id" :key="brand.id">
              <span class="brand-name">{{ brand.sh_name }}</span>
              <span class="brand-id">ID: {{ brand.id }}</span>
            </el-radio>
          </div>
        </el-radio-group>
        <div v-if="selectedBrand" class="selected-tip">
          <i class="el-icon-check"></i>
          已选择：<strong>{{ selectedBrand.sh_name }}</strong>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bindDialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="bindLoading"
          :disabled="!selectedBrandId || brandList.length === 0"
          @click="submitBindBrand"
        >
          {{ bindLoading ? '绑定中...' : '确认绑定' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import * as echarts from 'echarts'
import axios from 'axios'
import Cookie from 'js-cookie'

const token = Cookie.get('token')
const Request = axios.create({
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    comlistToken: token
  }
})

export default {
  name: 'Dashboard',
  data () {
    return {
      // ---------- 通用 ----------
      userType: '',
      user: {
        name: '',
        avatar: 'https://caixiao.lianglianyn.com/index/upload/02_dian/6a29013d6bfba_1781072189.jpg',
        role: '超级管理员'
      },
      hasShop: true,
      shopType: '',
      brandId: '', // 品牌方ID（批发商已绑定的，或零售商待绑定的）

      // ---------- 批发商品牌数据 ----------
      isWholesaler: false, // 是否为批发商
      brand: {
        id: '',
        name: '',
        avatar: ''
      },
      brandStats: {
        goods_sum: 0,
        jx_sum: 0,
        ht_sum: 0
      },
      orderStats: {
        order_num: 0,
        jie_num: 0,
        isok_num: 0,
        total_amount: 0,
        pay_type_amount: {}
      },
      orderChartInstance: null,
      payChartInstance: null,

      // ---------- 原有数据 ----------
      jxdata: { goods_sum: 0, order_sum: 0 },
      todo: { shop_pending: 0, card_pending: 0 },
      shopStats: { pending: 0, approved: 0, rejected: 0 },
      cardStats: { pending: 0, approved: 0, rejected: 0 },
      shopChartInstance: null,
      cardChartInstance: null,

      // ---------- 绑定品牌方弹窗 ----------
      bindDialogVisible: false,
      brandList: [],
      selectedBrandId: null,
      selectedBrand: null,
      brandLoading: false,
      bindLoading: false
    }
  },
  mounted () {
    // 1. 读取用户信息
    this.userType = localStorage.getItem('user_type') || ''
    this.user.name = localStorage.getItem('user_name') || ''
    this.brandId = localStorage.getItem('sh_id') || ''

    // 2. 判断是否有店铺/认证
    const shId = localStorage.getItem('sh_id')
    this.hasShop = shId && shId !== 'null' && shId !== 'undefined' && shId.trim() !== '' && Number(shId) > 0

    if (this.userType === 'wholesaler' && this.hasShop) {
      this.isWholesaler = true
      this.brand.id = this.brandId || '未绑定'
      this.brand.name = this.user.name || '批发商'
      this.fetchBrandData()
    } else if (this.hasShop) {
      this.getshop()
      this.fetchData()
    }
  },
  beforeDestroy () {
    // 销毁所有图表实例
    if (this.shopChartInstance) {
      this.shopChartInstance.dispose()
      this.shopChartInstance = null
    }
    if (this.cardChartInstance) {
      this.cardChartInstance.dispose()
      this.cardChartInstance = null
    }
    if (this.orderChartInstance) {
      this.orderChartInstance.dispose()
      this.orderChartInstance = null
    }
    if (this.payChartInstance) {
      this.payChartInstance.dispose()
      this.payChartInstance = null
    }
  },
  methods: {
    // ==========================================
    async fetchBrandData () {
      if (!this.brandId) {
        this.$message.warning('未获取到绑定的品牌方ID，请先绑定或联系管理员')
        return
      }
      try {
        const numRes = await request.post('/admin/brand_index.php', {
          a: 'getnum',
          brand_id: this.brandId
        })
        const orderRes = await request.post('/admin/brand_index.php', {
          a: 'getorder',
          brand_id: this.brandId
        })

        const numData = numRes
        if (numData.code === '0' || numData.code === 0) {
          this.brandStats.goods_sum = numData.goods_sum || 0
          this.brandStats.jx_sum = numData.jx_sum || 0
          this.brandStats.ht_sum = numData.ht_sum || 0
        } else {
          this.$message.error(numData.msg || '获取统计数据失败')
        }
        const orderData = orderRes
        if (orderData.code === '0') {
          this.orderStats.order_num = orderData.order_num || 0
          this.orderStats.jie_num = orderData.jie_num || 0
          this.orderStats.isok_num = orderData.isok_num || 0
          this.orderStats.total_amount = orderData.total_amount || 0
          this.orderStats.pay_type_amount = orderData.pay_type_amount || {}

          // 渲染图表
          this.$nextTick(() => {
            this.initBrandCharts()
          })
        } else {
          this.$message.error(orderData.msg || '获取订单数据失败')
        }
      } catch (error) {
        console.error('批发商品牌数据加载失败:', error)
        this.$message.error('网络异常，请稍后重试')
      }
    },

    // 批发商图表初始化
    initBrandCharts () {
      // 左侧：订单统计柱状图（订单总数 / 可接单 / 已完成）
      if (!this.orderChartInstance) {
        this.orderChartInstance = echarts.init(this.$refs.orderChart)
      }
      const orderData = [
        { name: '订单总数', value: this.orderStats.order_num },
        { name: '可接单', value: this.orderStats.jie_num },
        { name: '已完成', value: this.orderStats.isok_num }
      ]
      this.orderChartInstance.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: orderData.map(item => item.name),
          axisLabel: { fontSize: 14 }
        },
        yAxis: {
          type: 'value',
          name: '订单数'
        },
        series: [
          {
            name: '订单数',
            type: 'bar',
            data: orderData.map(item => item.value),
            itemStyle: {
              color: '#409EFF'
            },
            label: {
              show: true,
              position: 'top',
              formatter: (params) => params.value
            }
          }
        ]
      })

      // 右侧：支付方式金额饼图
      if (!this.payChartInstance) {
        this.payChartInstance = echarts.init(this.$refs.payChart)
      }
      const payData = Object.entries(this.orderStats.pay_type_amount).map(([name, value]) => ({
        name,
        value
      }))
      if (payData.length === 0) {
        this.payChartInstance.setOption({
          title: { text: '暂无支付数据', left: 'center', top: 'center' }
        })
        return
      }
      this.payChartInstance.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: ￥{c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '支付方式',
            type: 'pie',
            radius: '50%',
            data: payData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              formatter: '{b}\n￥{c} ({d}%)'
            }
          }
        ]
      })
    },

    // 批发商统计卡片点击跳转（路由占位）
    goTo (module) {
      const routes = {
        goods: '/party/member',
        dealers: '/system/userjx',
        contracts: '/hetong/hetongList'
      }
      const path = routes[module]
      if (path) {
        this.$router.push(path)
      } else {
        this.$message.info('跳转功能开发中')
      }
    },

    // ==========================================
    // 原有方法（经销商/管理员/零售商）
    // ==========================================
    async getshop () {
      const response = await request.post('sh/sh_jiben_list.php', { user_id: localStorage.getItem('user_id') })
      if (response.code === 0) {
        this.shopType = response.list[0]?.sh_type || ''
      }
    },

    async fetchData () {
      const response = await request.post('/admin/brand_index.php', {
        a: 'getjxnum',
        jx_id: localStorage.getItem('jx_id')
      })
      console.log(response, 111111111111111111111111111111111)
      if (response.code === '0') {
        const data = response
        this.jxdata.goods_sum = data.goods_sum
        this.jxdata.order_sum = data.jie_num
        this.shopStats = { pending: Number(data.jie_num) - Number(data.doing_num) - Number(data.complete_num), approved: data.doing_num, rejected: data.complete_num }
        console.log(this.shopStats)
        this.cardStats = { pending: data.pay_type_amount.货到付款, approved: data.pay_type_amount.其他, rejected: 0 }
        this.$nextTick(() => {
          this.initCharts()
        })
      }
    },

    initCharts () {
      // 店铺扇形图
      if (!this.shopChartInstance) {
        this.shopChartInstance = echarts.init(this.$refs.shopChart)
      }
      const shopPieData = [
        { name: '可接单', value: this.shopStats.pending },
        { name: '配货中', value: this.shopStats.approved },
        { name: '已完成', value: this.shopStats.rejected }
      ]
      this.shopChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '店铺审核状态',
            type: 'pie',
            radius: '50%',
            data: shopPieData,
            emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } },
            label: { formatter: '{b}\n{d}%' }
          }
        ]
      })

      // 证件扇形图
      if (!this.cardChartInstance) {
        this.cardChartInstance = echarts.init(this.$refs.cardChart)
      }
      const cardPieData = [
        { name: '货到付款', value: this.cardStats.pending },
        { name: '其他', value: this.cardStats.approved }
      ]
      this.cardChartInstance.setOption({
        tooltip: { trigger: 'item', formatter: '{a} <br/>{b}: {c} ({d}%)' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '证件审核状态',
            type: 'pie',
            radius: '50%',
            data: cardPieData,
            emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: 'rgba(0,0,0,0.5)' } },
            label: { formatter: '{b}\n{d}%' }
          }
        ]
      })
    },

    gotoShopList () {
      this.$router.push('/system/user')
    },
    gotoCardList () {
      this.$router.push('/system/menu')
    },
    goRegister () {
      this.$router.push('/system/dept')
    },
    goAuth () {
      this.$router.push('/system/deptjx')
    },

    // ==========================================
    // 绑定品牌方（零售商专用）
    // ==========================================
    bindBrand () {
      this.openBindDialog()
    },

    async openBindDialog () {
      this.selectedBrandId = null
      this.selectedBrand = null
      this.brandList = []
      this.bindDialogVisible = true
      await this.fetchBrandList()
    },

    async fetchBrandList () {
      const shId = localStorage.getItem('sh_id')
      if (!shId) {
        this.$message.error('未获取到经销商信息，请重新登录')
        this.brandLoading = false
        return
      }
      this.brandLoading = true
      try {
        const response = await Request.post('https://caixiao.lianglianyn.com/admin/brand_list.php', {
          a: 'lists',
          page: '1',
          page_size: '20'
        })
        const res = response.data
        if (res.code === '0' || res.code === 0) {
          this.brandList = res.data || []
          if (this.brandList.length === 0) {
            this.$message.info('暂无品牌方可供绑定')
          }
        } else {
          this.$message.error(res.msg || '获取品牌列表失败')
          this.brandList = []
        }
      } catch (error) {
        console.error('获取品牌列表失败:', error)
        this.$message.error('网络异常，请稍后重试')
        this.brandList = []
      } finally {
        this.brandLoading = false
      }
    },

    handleBrandSelect (brand) {
      if (brand) {
        this.selectedBrand = brand
      } else {
        const found = this.brandList.find(b => String(b.id) === String(this.selectedBrandId))
        this.selectedBrand = found || null
      }
    },

    async submitBindBrand () {
      if (!this.selectedBrandId) {
        this.$message.warning('请选择一个品牌')
        return
      }
      const brand = this.brandList.find(b => String(b.id) === String(this.selectedBrandId))
      if (!brand) {
        this.$message.error('所选品牌不存在，请重新选择')
        return
      }
      const shId = localStorage.getItem('sh_id')
      if (!shId) {
        this.$message.error('未获取到经销商信息，请重新登录')
        return
      }
      this.bindLoading = true
      try {
        const response = await Request.post('https://caixiao.lianglianyn.com/admin/brand_list.php', {
          a: 'brandBind',
          brand_id: String(brand.id),
          brand_name: brand.sh_name,
          jx_id: String(shId),
          sh_main: shId
        })
        const res = response.data
        if (res.code === '0' || res.code === 0) {
          this.$message.success('绑定成功')
          this.bindDialogVisible = false
          this.fetchData()
        } else {
          this.$message.error(res.msg || res.res || '绑定失败，请稍后重试')
        }
      } catch (error) {
        console.error('绑定品牌失败:', error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.bindLoading = false
      }
    },

    handleDialogClose () {
      this.brandLoading = false
      this.bindLoading = false
      this.selectedBrandId = null
      this.selectedBrand = null
    }
  }
}
</script>

<style scoped lang="scss">
.dashboard {
  padding: 20px;
  height: 90%;
  overflow: auto;

  .box-card {
    height: 100%;
  }

  // ---------- 通用用户信息 ----------
  .user-info {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    position: relative;

    .info {
      margin-left: 20px;
      .name {
        font-size: 18px;
        font-weight: bold;
      }
      .role {
        color: #909399;
        font-size: 14px;
      }
      .id {
        color: #909399;
        font-size: 12px;
        margin-top: 2px;
      }
    }

    .user-actions {
      margin-left: auto;
      display: flex;
      gap: 10px;
      align-items: center;
    }
  }

  // ---------- 待办事项 ----------
  .todo-list {
    display: flex;
    justify-content: space-around;
    .todo-item {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        font-size: 14px;
        color: #606266;
      }
    }
  }

  // ---------- 批发商统计卡片 ----------
  .stat-cards {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;

    .stat-item {
      text-align: center;
      cursor: pointer;
      padding: 16px 20px;
      border-radius: 8px;
      transition: background 0.2s;
      flex: 1;

      &:hover {
        background-color: #f5f7fa;
      }

      .stat-num {
        font-size: 32px;
        font-weight: bold;
        color: #409EFF;
      }
      .stat-label {
        font-size: 14px;
        color: #606266;
        margin-top: 6px;
      }
    }
  }

  // ---------- 无店铺/认证提示 ----------
  .no-shop-tip {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 60vh;
    padding: 40px 20px;
    background: #fafafa;
    border-radius: 8px;
    .el-empty {
      .el-empty__image {
        width: 120px;
      }
      .el-empty__description {
        font-size: 16px;
        color: #606266;
        margin-top: 10px;
      }
    }
  }

  // ---------- 绑定品牌方弹窗 ----------
  .brand-radio-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    padding: 4px 0;

    .brand-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #e4e7ed;
      transition: all 0.25s ease;
      cursor: pointer;

      &:hover {
        border-color: #409eff;
        background-color: #f5f7fa;
      }

      &.is-active {
        border-color: #409eff;
        background-color: #ecf5ff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
      }

      .el-radio {
        display: flex;
        align-items: center;
        width: 100%;
        margin-right: 0;
        height: auto;

        .el-radio__label {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex: 1;
          padding-left: 8px;
          font-size: 15px;

          .brand-name {
            font-weight: 500;
            color: #303133;
          }

          .brand-id {
            font-size: 12px;
            color: #909399;
            margin-left: 16px;
          }
        }
      }
    }
  }

  .selected-tip {
    margin-top: 16px;
    padding: 10px 16px;
    background-color: #f0f9eb;
    border-radius: 6px;
    color: #67c23a;
    font-size: 14px;

    i {
      margin-right: 6px;
    }

    strong {
      color: #303133;
    }
  }

  .brand-empty {
    padding: 20px 0;
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}
</style>
